import {ExternalModule} from '../external.module';
import {ComponentsModule} from '../components/components.module';
import {TemplatesRoutingModule} from './templates-routing.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthPageTemplateComponent} from './auth-page-template/auth-page-template.component';
import {HomePageTemplateComponent} from './home-page-template/home-page-template.component';
import {InnerPageTemplateComponent} from './inner-page-template/inner-page-template.component';
import {NgScrollbarModule} from 'ngx-scrollbar';


@NgModule({
  declarations: [AuthPageTemplateComponent, HomePageTemplateComponent, InnerPageTemplateComponent],
  imports: [
    TemplatesRoutingModule,
    CommonModule,
    ExternalModule,
    ComponentsModule,
    NgScrollbarModule
  ]
})
export class TemplatesModule { }
